import FieldGroupController from './field_group_controller';

export default class extends FieldGroupController {
  cleanErrors() {
    const isInputInvalid = this.inputTarget.classList.contains('is-error');
    const hideError = isInputInvalid && this.errorTarget;

    if (hideError) {
      this.errorTarget.classList.add('hidden');
      this.select2Container().classList.remove('is-error');
    }
  }

  addError() {
    this.createErrorElement();
    this.select2Container().classList.add('is-error');
    this.addErrorText();
    this.errorTarget.classList.remove('hidden');
  }

  createErrorElement() {
    if (!this.hasErrorTarget) {
      const errorElement = document.createElement('div');
      errorElement.classList.add('text-red-600', '-mt-2', 'text-xs', 'mb-4', 'inline-block');
      errorElement.setAttribute('data-field-select2-group-target', 'error');
      this.select2Container().after(errorElement);
    }
  }

  /* eslint-disable class-methods-use-this */
  focusOnFirstInvalid() {}
  /* eslint-enable class-methods-use-this */

  select2Container() {
    return this.element.querySelector('.select2-container');
  }
}
